import {
  Stack,
  Paper,
  Text,
  Group,
  Badge,
  Table,
  Loader,
  Center,
} from "@mantine/core";
import { IconFileDescription } from "@tabler/icons-react";
import { useMyMacroRequests } from "../../../hooks/admin/useMacroRequests";

const STATUS_COLORS: Record<string, string> = {
  pending: "orange",
  approved: "green",
  rejected: "red",
};

export default function MyMacroRequests() {
  const { data: requests = [], isLoading } = useMyMacroRequests();

  if (isLoading) {
    return (
      <Center p="xl">
        <Loader />
      </Center>
    );
  }

  if (requests.length === 0) {
    return (
      <Paper p="xl" withBorder>
        <Center>
          <Stack align="center" gap="xs">
            <IconFileDescription
              size={40}
              color="var(--mantine-color-gray-5)"
            />
            <Text c="dimmed">
              You haven&apos;t submitted any macro requests
            </Text>
          </Stack>
        </Center>
      </Paper>
    );
  }

  return (
    <Paper p="md" withBorder>
      <Stack gap="md">
        <Group gap="sm">
          <IconFileDescription
            size={20}
            color="var(--mantine-color-violet-6)"
          />
          <Text fw={600}>My Macro Requests</Text>
          <Badge color="violet" variant="light" size="sm">
            {requests.length}
          </Badge>
        </Group>

        <Table striped highlightOnHover>
          <Table.Thead>
            <Table.Tr>
              <Table.Th style={{ width: 130 }}>Code</Table.Th>
              <Table.Th>Description</Table.Th>
              <Table.Th style={{ width: 100 }}>Status</Table.Th>
              <Table.Th style={{ width: 130 }}>Date</Table.Th>
              <Table.Th>Review Notes</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {requests.map((request) => (
              <Table.Tr key={request.id}>
                <Table.Td>
                  <Text size="sm" fw={600} ff="monospace">
                    {request.code}
                  </Text>
                </Table.Td>
                <Table.Td>
                  <Text size="sm" lineClamp={1}>
                    {request.diagnosisDescription || "—"}
                  </Text>
                </Table.Td>
                <Table.Td>
                  <Badge
                    color={STATUS_COLORS[request.status] || "gray"}
                    variant="light"
                    size="sm"
                  >
                    {request.status}
                  </Badge>
                </Table.Td>
                <Table.Td>
                  <Text size="sm" c="dimmed">
                    {new Date(request.createdAt).toLocaleDateString()}
                  </Text>
                </Table.Td>
                <Table.Td>
                  {request.reviewNotes ? (
                    <Text size="sm" lineClamp={1}>
                      {request.reviewNotes}
                    </Text>
                  ) : (
                    <Text size="sm" c="dimmed">
                      —
                    </Text>
                  )}
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Stack>
    </Paper>
  );
}
